// @ts-expect-error: Missing type definitions for react-force-graph-2d
import type { NodeObject } from 'react-force-graph-2d'
import { useGeneralSettingsStore } from '@unholster/graphkit'
import { CategoryType } from '../graph/types'
import AccordionItem from './accordion-item'
import { useState, useEffect } from 'react'

import { Accordion } from '@/components/ui/accordion'

interface InfoCardProps {
  node: NodeObject
}

export const InfoCard = ({ node }: InfoCardProps) => {
  const categories = useGeneralSettingsStore((state) => state.categories)
  const [expandedFeed, setExpandedFeed] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (node.feeds.length === 1) {
      setExpandedFeed(node.feeds[0])
    } else {
      setExpandedFeed(undefined)
    }
  }, [node.feeds])

  return (
    <div className="h-full w-full p-5 pr-1">
      <div>
        <div>
          <div
            className="inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold text-white"
            style={{ backgroundColor: node.color }}
          >
            {categories[node.category as CategoryType as string].es}
          </div>
          <h2 className="mt-1 text-lg font-bold text-[#333333] underline underline-offset-1">
            {node.name}
          </h2>
        </div>
        <Accordion
          type="single"
          collapsible
          className="w-full"
          value={expandedFeed}
          onValueChange={(value) => {
            setExpandedFeed((prev) => (prev === value ? undefined : value))
          }}
        >
          {node.feeds.map((feed: string, index: number) => (
            <AccordionItem data={node.data} feed={feed} key={index} />
          ))}
        </Accordion>
      </div>
    </div>
  )
}
